import {Helmet} from 'react-helmet'
import {useTranslation} from '@/translations/i18n'
import {StyledPageHeading, StyledWrapper} from './style'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {AccessesValidatorsFilters} from '@/features/accesses/components/accesses-validators-filters/AccessesValidatorsFilters'
import {AccessesValidatorsList} from '@/features/accesses/components/accesses-validators-list/AccessesValidatorsList'
import {AccessesAccordionContextProvider} from '@/features/accesses/components/accesses-accordion-context-provider/AccessesAccordionContextProvider'

export const AccessesValidator = () => {
    const {t} = useTranslation()
    return (
        <AccessesAccordionContextProvider>
            <StyledWrapper>
                <Helmet title={t('accesses:validator_title')} />
                <StyledPageHeading direction="column" fullWidth align="stretch">
                    <PageHeading direction="column" gap={2}>
                        <h2>{t('accesses:validator_title')}</h2>
                    </PageHeading>
                    <AccessesValidatorsFilters />
                </StyledPageHeading>

                <AccessesValidatorsList />
            </StyledWrapper>
        </AccessesAccordionContextProvider>
    )
}
